import { motion } from "framer-motion";

// Premium breathing-orb loader (no generic spinners)
export default function Loader({ label = "" }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-6" data-testid="loader">
      <div className="relative w-16 h-16 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-[#4da6ff] blur-2xl opacity-40 animate-orb" />
        <motion.div
          className="w-10 h-10 rounded-full border border-[#4da6ff]/40"
          style={{ background: "radial-gradient(circle at 30% 30%, rgba(77,166,255,0.9), rgba(77,166,255,0.1))", boxShadow: "0 0 30px rgba(77,166,255,0.5)" }}
          animate={{ scale: [0.85, 1.12, 0.85], opacity: [0.5, 1, 0.5] }}
          transition={{ repeat: Infinity, duration: 3.6, ease: "easeInOut" }}
        />
      </div>
      {label && <p className="text-sm tracking-[0.2em] uppercase text-zinc-500">{label}</p>}
    </div>
  );
}

export function InlineOrb() {
  return (
    <motion.span
      className="inline-block w-4 h-4 rounded-full bg-[#4da6ff]"
      style={{ boxShadow: "0 0 14px rgba(77,166,255,0.6)" }}
      animate={{ scale: [0.8, 1.15, 0.8], opacity: [0.5, 1, 0.5] }}
      transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
    />
  );
}
